import React from 'react';
import { useTranslation } from 'react-i18next';
import About from '../sections/About';
import usePageMeta from '../hooks/usePageMeta';
import useLangPrefix from '../hooks/useLangPrefix';

function AboutPage() {
  const { t } = useTranslation();
  const langPrefix = useLangPrefix();

  usePageMeta({
    title: `${t('about.name')} | ${t('about.title')}`,
    description: t('about.bio1'),
    path: `${langPrefix}/about`,
  });

  const values = t('about.values', { returnObjects: true });

  return (
    <>
      <h1 className="visually-hidden">{t('about.name')} — {t('about.title')}</h1>
      <About />
      <section className="py-5 py-lg-6 bg-light border-top">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-lg-8 text-center">
              <h2 className="h3 fw-semibold text-navy mb-0">{t('about.valuesHeading')}</h2>
            </div>
          </div>
          <div className="row g-4">
            {Array.isArray(values) &&
              values.map((value, i) => (
                <div className="col-md-4" key={i}>
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body p-4">
                      <h3 className="h6 fw-semibold text-navy mb-3">{value.title}</h3>
                      <p className="card-text small text-muted mb-0">{value.description}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutPage;
